import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Profile from "@/pages/Profile";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Dashboard from "@/pages/Dashboard";
import Costings from "@/pages/Costings";
import CostingEditor from "@/pages/CostingEditor";
import Quotations from "@/pages/Quotations";
import QuotationDetail from "@/pages/QuotationDetail";
import Nego from "@/pages/Nego";
import Activities from "@/pages/Activities";
import { Customers, Products } from "@/pages/MasterPages";
import Reports from "@/pages/Reports";
import Forecast from "@/pages/Forecast";
import Reminders from "@/pages/Reminders";
import Maintenance from "@/pages/Maintenance";
import MaintenanceEditor from "@/pages/MaintenanceEditor";
import UsersPage from "@/pages/Users";
import PlatformCompanies from "@/pages/PlatformCompanies";
import SettingsPage from "@/pages/Settings";
import Tech from "@/pages/Tech";
import Proforma from "@/pages/Proforma";

const Protected = ({ children, admin, superadmin, tech }) => {
  const { user, isAdmin } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-slate-400">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !isAdmin) return <Navigate to="/" replace />;
  if (superadmin && user.platform_role !== "superadmin") return <Navigate to="/" replace />;
  if (user.role === "teknisi" && !tech) return <Navigate to="/tech" replace />;
  return children;
};

const TechGate = ({ children }) => {
  const { user } = useAuth();
  return user?.role === "teknisi" ? <Navigate to="/tech" replace /> : children;
};

const LoginRoute = ({ register }) => {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return register ? <Register /> : <Login />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/register" element={<LoginRoute register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route element={<Protected tech><Layout /></Protected>}>
              <Route index element={<TechGate><Dashboard /></TechGate>} />
              <Route path="tech" element={<Tech />} />
              <Route path="costings" element={<Costings />} />
              <Route path="costings/new" element={<CostingEditor />} />
              <Route path="costings/:id" element={<CostingEditor />} />
              <Route path="quotations" element={<Quotations />} />
              <Route path="quotations/:id" element={<QuotationDetail />} />
              <Route path="nego" element={<Nego />} />
              <Route path="proforma" element={<Proforma />} />
              <Route path="activities" element={<Activities />} />
              <Route path="customers" element={<Customers />} />
              <Route path="products" element={<Products />} />
              <Route path="reports" element={<Reports />} />
              <Route path="forecast" element={<Forecast />} />
              <Route path="quote-reminders" element={<Reminders />} />
              <Route path="maintenance" element={<Maintenance />} />
              <Route path="maintenance/new" element={<MaintenanceEditor />} />
              <Route path="maintenance/:id" element={<MaintenanceEditor />} />
              <Route path="profile" element={<Profile />} />
              <Route path="users" element={<Protected admin><UsersPage /></Protected>} />
              <Route path="platform" element={<Protected superadmin><PlatformCompanies /></Protected>} />
              <Route path="settings" element={<Protected admin><SettingsPage /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
